import React from 'react';
import { PropTypes } from 'prop-types';
import { useEHRContext } from 'contexts/EHRContext';
import {
  Dialog, DialogActions, DialogContent, DialogTitle,
} from '@material-ui/core';
import './Modals.css';
import { useHistory } from 'react-router-dom';
import { useUserContext } from 'store';

export function EmergencyAccess({ isOpen, patient, setIsOpen }) {
  const { setPatient } = useEHRContext();
  const [user] = useUserContext();
  const history = useHistory();
  return (
    <Dialog
      className="emergencyAccessModal"
      open={isOpen}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        Acesso de emergência
        <button onClick={() => setIsOpen(false)} className="br-button close circle small" type="button" data-dismiss="br-modal" aria-label="Close">
          <i className="fas fa-times" aria-hidden="true" />
        </button>

      </DialogTitle>

      <DialogContent>
        <div className="emergencyAccessModal-text">
          <p> Ao prosseguir o acesso será permitido e registrado em nosso sistema como um caso de emergência </p>
        </div>
      </DialogContent>
      <DialogActions>
        <button onClick={() => setIsOpen(false)} className="emergencyAccessModal-closeButton" type="button">
          Cancelar
        </button>
        <button
          className="emergencyAccessModal-accessButton" type="button"
          onClick={() => {
            setPatient({
              resourceId: patient.patientIdentifier,
              purposeOfUse: 'Emergencia',
              organizationId: user.userData.rolesPerOrganization[0].id,
            });
            history.push('/registros');
          }}
        >
          Continuar
        </button>
      </DialogActions>
    </Dialog>

  );
}
EmergencyAccess.propTypes = {
  setIsOpen: PropTypes.bool.isRequired,
  isOpen: PropTypes.bool.isRequired,
  patient: PropTypes.element.isRequired,
};
